module.exports = __webpack_public_path__ + "static/mabry-light-pro-110ba2917a793398cfa747755ed5ab7f.ttf";